import * as Sentry from '@sentry/react';

const isLocalhost =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1';

// Initialize Sentry
if (!isLocalhost) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_PS_ENV,
    release: import.meta.env.VITE_APP_VERSION,
    replaysSessionSampleRate:
      import.meta.env.VITE_PS_ENV === 'test' ? 1.0 : 0.1,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    ignoreErrors: [
      /^Non-Error promise rejection captured with value:/i,
      /^Object captured as promise rejection with keys:/i,
    ],
  });
}
